import { Component, Input, OnInit } from '@angular/core';

import * as _ from 'lodash';
@Component({
    selector: 'summary-risk',
    templateUrl: './summary-risk.component.html',
    styleUrls: ['./summary-risk.component.scss'],
    standalone: false
})
export class SummaryRiskComponent implements OnInit {
  _ = _;
  @Input() riskRange: number[] = [1, 5];
  @Input() title: string = 'Votre indicateur de risque';
  math = Math;

  minRiskThreshold = 3;
  maxRiskThreshold = 4;
  constructor() {}

  ngOnInit() {}
  indexIsInRange(index) {
    // check if index is in range of risk range (1, 5)
    return this.riskRange[0] <= index && index <= this.riskRange[1];
  }
}
